var _rect, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 88,
    height: 88,
    rx: 22,
    fill: "#FF965D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3869)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "#E31D93"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 50.55C24.8 49.5835 25.6358 48.8 26.6667 48.8H32.5334C33.5643 48.8 34.4 49.5835 34.4 50.55V60.8H24.8V50.55Z",
    fill: "#E31D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2001 38.7091C39.2001 37.6547 40.0358 36.8 41.0667 36.8H46.9334C47.9643 36.8 48.8001 37.6547 48.8001 38.7091V60.8H39.2001V38.7091Z",
    fill: "#E31D93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6001 29.16C53.6001 28.0775 54.4358 27.2 55.4668 27.2H61.3334C62.3644 27.2 63.2001 28.0775 63.2001 29.16V60.8H53.6001V29.16Z",
    fill: "#E31D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrow);
export default __webpack_public_path__ + "static/media/icGrow.4bb3b7ac606340cef972dd0d15aefc56.svg";
export { ForwardRef as ReactComponent };